import { render, staticRenderFns } from "./AuthorPage.vue?vue&type=template&id=5325a74b&"
import script from "./AuthorPage.vue?vue&type=script&lang=js&"
export * from "./AuthorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports